import React from 'react'
import { EXAMINATION_APPOINTMENT_SEARCH } from 'constants/path'
import { SectionGrant } from 'components/functional'
import { canShowSidebar } from 'policies/ExaminationAppointmentPolicy'
import MenuItem from '../MenuItem'
import { useQuery } from '../useQuery'

type Props = ReturnType<typeof useQuery>

export const ExaminationAppointmentSearchMenuItem: React.FC<Props> = ({ viewer }) => {
  return (
    <SectionGrant authorized={canShowSidebar(viewer)}>
      <MenuItem href={EXAMINATION_APPOINTMENT_SEARCH}>予約検索</MenuItem>
    </SectionGrant>
  )
}
